import { FC } from 'react';

import { useCardOfferDataContext } from 'shared/context/CardContext';
import { useListingLayoutIsShortSelector } from 'shared/store/clientSide/slices/listingLayout';

import { FooterFactory } from './FooterFactory';

export const FooterFactoryContainer: FC = () => {
  const { areaParts, amenities } = useCardOfferDataContext();
  const isShortListing = useListingLayoutIsShortSelector();

  return <FooterFactory amenities={amenities} areaParts={areaParts} isShortListing={isShortListing} />;
};
